import { Component, OnInit, OnDestroy } from "@angular/core";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { CatalogoService } from "app/main/apps/shared/services/rest/catalogo.service";
import { finalize } from "rxjs/operators";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { Subscription } from "rxjs";
import { DialogNuevoServicioComponent } from "./components/dialog-nuevo-servicio/dialog-nuevo-servicio.component";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { CategoriaDTO } from "../../shared/interfaces/categoria.interface";
import { NuevoServicioDTO } from "../../shared/models/servicio.model";
import { fuseAnimations } from "@fuse/animations";
@Component({
    selector: "app-catalogo-servicios",
    templateUrl: "./catalogo-servicios.component.html",
    styleUrls: ["./catalogo-servicios.component.scss"],
    animations: fuseAnimations,
})
export class CatalogoServiciosComponent implements OnInit, OnDestroy {
    catalogos: any[] = [];
    subscripciones: Subscription;
    private _idGrupo:number;
    constructor(
        private _catalogoSrvc: CatalogoService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _dialogSrvc: DialogService, 
        private _notificacionesSrvc: NotificacionesService
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._catalogoSrvc
                .fetchCatalogoServicios()
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((resp) => (this.catalogos = resp))
        );
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }

    buscaServicios(id:number){
        this._idGrupo=id;
        this._catalogoSrvc.fetchServicios(id).subscribe(resp=>{
            this._catalogoSrvc.onServiciosChanged.next(resp);
        })
    }

    refrescarTabla(){
        //Refresco la tabla cuando se cambia el valor. Por eso guardo el valor anteriormente seleccionado
        //console.log('llego a refrescar');
        if (Number(this._idGrupo).toString() != 'NaN'){
        this.buscaServicios(this._idGrupo)
        }
    }

    limpiarTabla(event){
        this._catalogoSrvc.onCategoriaChanged.next(true); //Se cambio de pestaña
        this._catalogoSrvc.onServiciosChanged.next(null);
    }

    nuevoServicio(categoria:CategoriaDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogNuevoServicioComponent,
            "clase-dialog",
            "700px",
            {categoria:categoria,grupo:this._idGrupo}
        );
    
        dialogRef.afterClosed().subscribe((result) => {
            if (result){
                this._fuseProgressBarService.show();
                let atributos:string[]=[];
                Object.keys(result).forEach(key =>{
                    if (key.startsWith('attr_')){
                        atributos.push(Reflect.get(result,key));
                    }
                } );
                let servicio = new NuevoServicioDTO(result.nombre, result.desde, result.hasta,result.medida, result.tiempo == -1?null:result.tiempo, atributos);           
                this._catalogoSrvc.saveServicio(result.grupo,servicio)
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe(resp=>{
                        this.refrescarTabla();
                        this._notificacionesSrvc.mostrarNotificacion('Servicio agregado exitosamente','success');        
                    })      
            }
        });
    }
}
